<template>
  <div
    class="field__date"
  >
    <div
      v-bind:id="`select--day-${id}`"
      class="select"
    >
      <div
        v-bind:class="[
          'select__value',
          errors.has('dob') ? 'is-invalid' : ''
        ]"
        v-on:click="toggleDropdown('day')"
      >{{getDay}} <AngleDown class="icon-dropdown" /></div>
      <ul v-bind:class="{slect__dropdown: true, active: selecteToggle.day }">
        <li
          v-for="day in 31"
          v-bind:key="day"
          v-on:click="updateDob(day, 'day')"
          v-bind:class="[
            'select__option',
            dob.day === day ? 'select__option--selected' : ''
          ]"
        >
          <span v-if="day < 10">0{{day}}</span>
          <span v-else>{{day}}</span>
        </li>
      </ul>
    </div>
    <div
      v-bind:id="`select--month-${id}`"
      class="select"
    >
      <div
        v-bind:class="[
          'select__value',
          errors.has('dob') ? 'is-invalid' : ''
        ]"
        v-on:click="toggleDropdown('month')"
      >{{getMonth}} <AngleDown class="icon-dropdown" /></div>
      <ul v-bind:class="{slect__dropdown: true, active: selecteToggle.month }">
        <li
          v-for="month in 12"
          v-bind:key="month"
          v-bind:data-value="month"
          v-on:click="updateDob(month, 'month')"
          v-bind:class="[
            'select__option',
            dob.month === month ? 'select__option--selected' : ''
          ]"
        >
          <span v-if="month < 10">0{{month}}</span>
          <span v-else>{{month}}</span>
        </li>
      </ul>
    </div>
    <div
      v-bind:id="`select--year-${id}`"
      class="select"
    >
      <div
        v-bind:class="[
          'select__value',
          errors.has('dob') ? 'is-invalid' : ''
        ]"
        v-on:click="toggleDropdown('year')"
      >{{dob.year}} <AngleDown class="icon-dropdown" /></div>
      <ul v-bind:class="{slect__dropdown: true, active: selecteToggle.year }">
        <li
          v-for="year in 100"
          v-bind:key="getYear(year)"
          v-bind:data-value="getYear(year)"
          v-on:click="updateDob(getYear(year), 'year')"
          v-bind:class="[
            'select__option',
            dob.year === getYear(year) ? 'select__option--selected' : ''
          ]"
        >
          <span>{{getYear(year)}}</span>
        </li>
      </ul>
    </div>
    <div
      class="is-danger error--dob"
      v-show="errors.has('dob')"
    >
      Please select appropriate date.
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import field from '@/components/mixin/field';
import AngleDown from '@/assets/icons/angle-down.svg';

export default {
  name: 'DateInput',
  mixins: [field],
  props: [
    'index',
    'field',
    'initial',
  ],
  components: {
    AngleDown,
  },
  data() {
    return {
      dobString: '',
      startYear: 1918,
      dob: {
        day: 'DD',
        month: 'MM',
        year: 'YYYY',
      },
      selecteToggle: {
        day: false,
        month: false,
        year: false,
      },
    };
  },
  computed: {
    getDay() {
      return this.formatNumber(this.dob.day, 2);
    },
    getMonth() {
      return this.formatNumber(this.dob.month, 2);
    },
  },
  created() {
    if (this.initial) {
      const initialDob = this.initial.split('/');

      if (initialDob.length >= 2) {
        this.dob = {
          day: initialDob[0],
          month: initialDob[1],
          year: initialDob.length === 3 ? initialDob[2] : 'YYYY',
        };

        this.updateDobString();
      }
    }
  },
  mounted() {
    const self = this;
    const daySelectId = `select--day-${self.id}`;
    const monthSelectId = `select--month-${self.id}`;
    const yearSelectId = `select--year-${self.id}`;

    document.addEventListener('click', (event) => {
      const dayFlag = event.target.closest(`#${daySelectId}`);
      const monthFlag = event.target.closest(`#${monthSelectId}`);
      const yearFlag = event.target.closest(`#${yearSelectId}`);

      if (dayFlag && !monthFlag && !yearFlag) {
        // does nothing;
      } else {
        self.selecteToggle.day = false;
      }

      if (!dayFlag && monthFlag && !yearFlag) {
        // does nothing;
      } else {
        self.selecteToggle.month = false;
      }

      if (!dayFlag && !monthFlag && yearFlag) {
        // Do nothing;
      } else {
        self.selecteToggle.year = false;
      }
    });
  },
  methods: {
    updateDobString() {
      this.dobString = `${this.getDay}/${this.getMonth}/${this.dob.year}`;
      // this.dobString = `${this.getDay}/${this.getMonth}`;

      this.$emit('input', this.dobString);
    },
    updateDob(value, toggleTarget) {
      this.dob[toggleTarget] = value;
      this.updateDobString();
      this.toggleDropdown(toggleTarget);
    },
    toggleDropdown(item) {
      switch (item) {
        case 'day':
          this.selecteToggle.day = !this.selecteToggle.day;
          break;
        case 'month':
          this.selecteToggle.month = !this.selecteToggle.month;
          break;
        case 'year':
          this.selecteToggle.year = !this.selecteToggle.year;
          break;
        default:
      }
    },
    getYear(year) {
      return year + this.startYear;
    },
    formatNumber(num, size) {
      const s = `000000000${num}`;

      return s.substr(s.length - size);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$field-width: 290px;
$field-date-gap: 8px;

$selected-background: $charcoal-dark;
$selected-color: $white;

// Custom styles
.field__date {
  width: $field-width;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .icon-dropdown {
    margin-left: $field-date-gap;
  }
}

.select__value,
.select__option {
  @include nike-heading;
}

.select__value {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.select__option--selected {
  background: $selected-background;
  color: $selected-color;
}

.error--hide {
  .error--dob {
    display: none;
  }

  .select__value.is-invalid {
    border-color: #ddd;
  }
}
</style>

<style scoped lang="scss">
  .is-danger {
    flex: 0 0 auto;
  }
</style>
